// function to validate image
export const validImage = (fileName) => {
    return (/\.(jpe?g|png|gif|jfif|bmp|svg)$/i.test(fileName))
}


// function to validate file
export const validVideo = (fileName) => {
    return (/^.*\.(avi|wmv|flv|mpg|mp4|mov)$/i.test(fileName))
}

// function to validate file
export const validFile = (fileName) => {
    return (/^.*\.(jpe?g|png|gif|jfif|bmp|svg|pdf|xlsx|xls|ZIP|TXT|TAR|PPTX|DOCX|doc|pptx|ppt|pps|ppsx|odp|CSV|CVS|RAR)$/i.test(fileName))
}
// function to validate many files
export const validFiles = (files) => {
    for (let i = 0; i < files?.length; i++) {
        if (/^.*\.(jpe?g|png|gif|jfif|bmp|svg|pdf|xlsx|xls|ZIP|TXT|TAR|PPTX|DOCX|doc|pptx|ppt|pps|ppsx|odp|CSV|CVS|RAR)$/i.test(files[i].name)) {
            console.log('valid file')
        } else {
            return false
        }
      }
    return true
}